import { render, staticRenderFns } from "./SendMailModal.vue?vue&type=template&id=8621ddd4&scoped=true"
import script from "./SendMailModal.vue?vue&type=script&lang=js"
export * from "./SendMailModal.vue?vue&type=script&lang=js"
import style0 from "./SendMailModal.vue?vue&type=style&index=0&id=8621ddd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8621ddd4",
  null
  
)

export default component.exports